<template>
  <div class="container">
    <img class="banner" src="@/assets/images/gxqgouche2212/banner.jpg" alt="" />
    <div class="login-form">
      <div class="login-title">用户登录</div>
      <van-field class="account-ipt" v-model="mobile" type="number" placeholder="请输入手机号" />
      <van-field class="account-ipt" maxlength="6" v-model="sms_code" type="number" placeholder="请输入短信验证码">
        <template #button>
          <div class="verification-code" v-if="!time_lock" @click="handleVerification">获取验证码</div>
          <div class="verification-code" v-else>{{ time }}秒后重新获取</div>
        </template>
      </van-field>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper">
          <div class="block" @click.stop>
            <div class="block-title">请输入图形验证码</div>
            <input class="verification-ipt" maxlength="4" type="text" v-model="rand_code" />
            <div class="verification-img">
              <img v-if="showSrc" :src="src" class="verification-img" @click="sendVerification" alt="" />
            </div>
            <div class="code-btn" @click="handleSendSms">提交</div>
          </div>
        </div>
      </van-overlay>
      <!-- <span class="red-txt">*请您妥善保管账号密码，如若泄露，后果自负。</span> -->
      <div class="login-btn" @click="handleLogin">立即登录</div>
    </div>
    <div class="footer">
      <img src="@/assets/images/gxqgouche2212/foot.png" alt="" />
    </div>
  </div>
</template>

<script>
import { login, sendSmscode, getRandCode } from '@/service/gxqgouche2212/index'
export default {
  name: 'Login',
  data() {
    return {
      time: 0,
      timer: null, // 计时器
      time_lock: false,
      rand_code: '', // 随机码
      codeImg: '',
      showSrc: false,
      show: false,
      mobile: '',
      sms_code: '',
      captcha_key: '',
      src: '' // 图片请求src
    }
  },
  mounted() {
    // if (!window.location.origin.includes('2500city')) {
    //   this.src = `https://huodong-test.chinacici.com/api/221212/user/rand-code`
    // } else {
    //   this.src = window.location.origin + '/api/221212/user/rand-code'
    // }
  },
  methods: {
    handleSendSms() {
      let query = {
        captcha_val: this.rand_code,
        mobile: this.mobile,
        captcha_key: this.captcha_key
      }
      sendSmscode(query)
        .then((res) => {
          this.show = false
          this.rand_code = ''
          console.log(res)
          this.cutDown()
        })
        .catch((err) => {
          // this.show = false
          this.rand_code = ''
          this.$toast(err.msg || err.message || err)
          this.sendVerification()
        })
    },
    sendVerification() {
      getRandCode().then((res) => {
        this.src = res.data.captcha_val
        this.captcha_key = res.data.captcha_key
      })
    },
    cutDown() {
      this.time_lock = true
      this.time = 60
      this.timer = setInterval(() => {
        if (this.time <= 0) {
          clearInterval(this.timer)
          this.time_lock = false
        } else {
          this.time--
        }
      }, 1000)
    },
    handleVerification() {
      if (!this.mobile) {
        this.$toast('请输入手机号')
        return false
      } else {
        // 验证手机号
        const mobileReg = /^1[3456789]\d{9}$/
        if (!mobileReg.test(this.mobile)) {
          this.$toast('请输入正确的手机号码')
          return false
        } else {
          this.show = true
          this.showSrc = true
          this.sendVerification()
        }
      }
    },
    handleLogin() {
      if (!this.mobile) {
        this.$toast('请输入手机号')
        return false
      } else {
        if (!this.sms_code) {
          this.$toast('请输入验证码')
          return false
        }
      }
      let obj = {
        mobile: this.mobile,
        sms_code: this.sms_code
      }
      login(obj)
        .then((res) => {
          if (res.code == 0) {
            sessionStorage.setItem('gxqgc2212_auth_token', res.data.token)
            sessionStorage.setItem('gxqgc2212_mobile', this.mobile)
            this.$toast('登录成功')
            this.$router.push('/home')
          } else {
            this.$toast(res.message)
          }
        })
        .catch((err) => {
          this.$toast(err.msg || err.message || err)
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  height 100%
  overflow-y scroll
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .block {
    background-color: #fff;
    border-radius: 20px;
    padding: 100px 30px 50px 30px;
    .block-title{
      text-align: center
      margin-bottom: 30px;
      color: #000;
      font-weight: bold;
      font-size: 40px;
    }
    .verification-ipt{
      height: 80px;
      border: 1px solid #D8D8D8;
    }
    .verification-img{
      float: right
      width: 200px;
      height: 80px;
    }
    .code-btn{
      width: 562px;
      height: 90px;
      left: 0;
      right: 0;
      margin: 80px auto 0 auto;
      background: rgb(19,28,225)
      border: 1px solid #D8D8D8;
      border-radius: 50px;
      color #ffffff
      text-align center
      line-height 90px
      font-size: 32px;
      font-weight: bold;
    }
  }
  .banner
    width 100%
    height auto
  .login-form
    background #fff
    padding 68px 45px
    border-radius: 20px 20px 0px 0px;
    position relative
    top -50px
    .login-title
      text-align: center
      font-size: 34px;
      color: #111111
      margin-bottom: 30px;
    .title
      display flex
      align-items: center
      margin-bottom 50px
      .txt
        font-size: 40px;
        font-weight: 600;
        color: #131177;
        margin-left 10px
      img
        width: 40px;
        height: 40px;
    .account-ipt
      width: 660px
      height: 90px
      background: #FFFFFF;
      box-shadow: 0px 0px 15px 0px rgba(176, 200, 220, 0.4);
      border-radius: 10px;
      margin-bottom 30px
      margin-top 10px
    .verification-code
      color: rgb(19,28,225)
    .red-txt
      font-size: 24px;
      font-weight: 400;
      color: #FF0000;
    .login-btn
      margin-top 80px
      width: 662px;
      height: 90px;
      background: rgb(19,28,225)
      border: 1px solid #D8D8D8;
      border-radius: 10px;
      color #ffffff
      text-align center
      line-height 90px
      font-size: 32px;
      font-weight: bold;
  .footer
    position fixed
    bottom 0
</style>
